<template>
  <div class="popInfos" :style="{position:positions}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'popInfos',
  props: {
    positions: {
      type:String,
      default:"absolute"
    }
  },
  data(){
    return{
    }
  }
}
</script>
<style scoped >
  .popInfos{
    position: absolute;
    background: rgba(0,0,0,0.6);
    color: #fff;
    max-width: 400px;
    padding: 5px 10px;
    box-sizing: border-box;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    border-radius: 4px;
  
}

</style>